export const MitekConfig = {
  mode: '',
  documentType: '',
  mitekSDKPath: './../../assets/mitekSDK-4.9.5/mitekSDK/',
  options: {
    qualityPercent: 80,
  }
};
